export const FIRM_FRONTEND_LOGIN_PATH = '/authenticate/login';
export const FIRM_FRONTEND_MAGIC_LINK_PATH_PREFIX = '/authenticate/ml';
export const FIRM_FRONTEND_CHANGE_PASSWORD_PATH_PREFIX = '/authenticate/cp';

/**
 * Pure URL builder for firm-frontend login (no window / heavy imports).
 */
export const buildFirmFrontendLoginUrl = (
  firmSiteBaseUrl: string,
  currentSearch: string,
  {
    includeSessionTimeout,
  }: {
    includeSessionTimeout?: boolean;
  } = {},
) => {
  const baseUrl = (firmSiteBaseUrl || '').replace(/\/$/, '');
  const url = new URL(`${baseUrl}${FIRM_FRONTEND_LOGIN_PATH}`);
  const currentParams = new URLSearchParams(currentSearch);
  const companyName = currentParams.get('company_name');

  if (companyName) {
    url.searchParams.set('company_name', companyName);
  }

  if (includeSessionTimeout) {
    url.searchParams.set('session_timeout', 'true');
  }

  return url.toString();
};

const buildFirmFrontendAuthEntryUrl = (
  firmSiteBaseUrl: string,
  path: string,
  currentSearch: string,
) => {
  const baseUrl = (firmSiteBaseUrl || '').replace(/\/$/, '');
  const url = new URL(`${baseUrl}${path}`);
  const currentParams = new URLSearchParams(currentSearch);
  const companyName = currentParams.get('company_name');

  if (companyName) {
    url.searchParams.set('company_name', companyName);
  }

  return url.toString();
};

export const buildFirmFrontendMagicLinkUrl = (
  firmSiteBaseUrl: string,
  token: string,
  currentSearch: string,
) =>
  buildFirmFrontendAuthEntryUrl(
    firmSiteBaseUrl,
    `${FIRM_FRONTEND_MAGIC_LINK_PATH_PREFIX}/${encodeURIComponent(token)}`,
    currentSearch,
  );

export const buildFirmFrontendChangePasswordUrl = (
  firmSiteBaseUrl: string,
  token: string,
  currentSearch: string,
) =>
  buildFirmFrontendAuthEntryUrl(
    firmSiteBaseUrl,
    `${FIRM_FRONTEND_CHANGE_PASSWORD_PATH_PREFIX}/${encodeURIComponent(token)}`,
    currentSearch,
  );
